import { defaultConfig, defineTokens } from '@chakra-ui/react';

const cursor = defineTokens.cursor({
    ...defaultConfig.theme?.tokens?.cursor,
    checkbox: { value: 'pointer' },
    menuitem: { value: 'pointer' },
    option: { value: 'pointer' },
    radio: { value: 'pointer' },
    slider: { value: 'pointer' },
    switch: { value: 'pointer' },
});

export { cursor };
